import { IApplicationState } from '../../../../../../../types/types';
import { IChat } from '../../../../../../../rest/effects/chats/chat/types';
import { TChatId } from '../../../../../../../types/rest/IRestChat';

export const getChat = (
    state: IApplicationState,
    id: TChatId,
): IChat => {
    return state.chatView?.chats[id];
}
